let faqs = [];

fetch(window.faqJsonUrl)  .then(response => response.json())
  .then(data => {
    faqs = data;
  });

const input = document.getElementById("faq-search");
const results = document.getElementById("faq-search-results");

input.addEventListener("input", function () {

    const value = this.value.toLowerCase().trim();

    if(value === ""){
        results.style.display = "none";
        results.innerHTML = "";
        return;
    }

    const matches = faqs.filter(faq =>
        faq.question.toLowerCase().includes(value) ||
        faq.answer.toLowerCase().includes(value) ||
        faq.category.toLowerCase().includes(value)
    );

    results.innerHTML = "";

    if(matches.length === 0){

        results.innerHTML =
        `
        <div class="search-result">
            No FAQs found.
        </div>
        `;

        results.style.display = "block";
        return;
    }

    matches.slice(0,8).forEach(faq=>{

        const div=document.createElement("div");

        div.className="search-result";

        div.innerHTML=`
            <div class="search-question">${faq.question}</div>
            <div class="search-category">${faq.category}</div>
        `;

        div.onclick=()=>{

            window.location.href="/pages/faqs?q="+encodeURIComponent(faq.question);

        };

        results.appendChild(div);

    });

    results.style.display="block";

});

document.addEventListener("click", function(e){

    if(!e.target.closest(".faq-search-wrapper")){

        results.style.display="none";

    }

});